$(document).ready(function() {
  setMultiChoiceOptionHeights();

  // click to show more options
  $('.jb-show-more-options').click(function() {
    const container = $(this).closest('.jb-multi-select-options-container');
    const options = container.find('.jb-multi-select-options');
    const fullHeight = options[0].scrollHeight;

    options.css('max-height', fullHeight+'px');

    container.find('.jb-show-more-options').addClass('d-none');
    container.find('.jb-show-less-options').removeClass('d-none');
  });

  // click to show less options
  $('.jb-show-less-options').click(function() {
    const container = $(this).closest('.jb-multi-select-options-container');
    const options = container.find('.jb-multi-select-options');
    const collapsedHeight = container.data('collapsedHeight');

    options.css('max-height', collapsedHeight + 'px');
    container.find('.jb-show-less-options').addClass('d-none');
    container.find('.jb-show-more-options').removeClass('d-none');
  });
});


const setMultiChoiceOptionHeights = function () {
  // Loop through each multi-select container and apply height limiting logic.
  // If the number of options exceeds 5, limit the container's max-height to show only 5 options.
  // Also, store the collapsed height on the container for toggling later,
  // and reveal any options that were initially hidden with `d-none`.
  $('.jb-multi-select-options-container').each(function (index, element) {
    const parentDivOfOptions = $(element).find('.jb-multi-select-options');
    const options = parentDivOfOptions.find('> div');
    const optionsCount = options.length;
    const optionHeight = options.first().outerHeight(true);
    const collapsedHeight = optionHeight * 5;
    // Store height value on the container for later use
    $(element).data('collapsedHeight', collapsedHeight);

    let isSelected = $(element).data('is-selected');
    if (isSelected) {
      const fullHeight = parentDivOfOptions[0].scrollHeight;
      parentDivOfOptions.css('max-height', fullHeight+'px');
    } else {
      if (optionsCount > 5) {
        parentDivOfOptions.css('max-height', collapsedHeight + 'px');
        parentDivOfOptions.find('> .d-none').removeClass('d-none');
      }
    }
  });
}

export default setMultiChoiceOptionHeights;
